// extracted by mini-css-extract-plugin
module.exports = {"container":"rTg7oIxVStR4FxkDUY1ku","groupsList":"_3Ooy4-3WH1A7S9ZF3NUO7U"};